import React from 'react';

export function DriversPanel({ drivers, activeDimension, onDriverClick }) {
  const filtered = activeDimension
    ? drivers.filter(d => d.dimension === activeDimension)
    : drivers;

  if (filtered.length === 0) return null;

  return (
    <div className="msml-card !p-4 !gap-3 msml-slide-up" style={{ animationDelay: '0.1s' }} data-testid="drivers-card">
      <div className="flex items-center justify-between">
        <span className="msml-label">Score Drivers</span>
        {activeDimension && (
          <button onClick={() => onDriverClick?.(null)} className="text-[10px] text-[var(--msml-primary)] hover:underline">Show all</button>
        )}
      </div>
      <div className="space-y-2">
        {filtered.map((driver, idx) => (
          <button
            key={idx}
            onClick={() => onDriverClick?.(driver.dimension)}
            className="flex items-start gap-2 text-xs w-full text-left group hover:bg-white/[0.02] rounded p-1 -m-1 transition-colors"
            data-testid={`driver-${idx}`}
          >
            <div
              className="w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0"
              style={{ backgroundColor: driver.impact > 0 ? 'var(--msml-success)' : 'var(--msml-danger)' }}
            />
            <div className="min-w-0">
              <span className="text-[var(--msml-text-muted)] capitalize">{driver.dimensionLabel}: </span>
              <span className="text-[var(--msml-text-secondary)] group-hover:text-white transition-colors">{driver.reason}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
